export class HttpPostService {
  constructor(baseUrl) {
    this.baseUrl = baseUrl;
  }

  async search(filters) {
    const queryParams = new URLSearchParams({
      media_id: filters.media_id,
    });

    if (filters.author_id) {
      queryParams.append('author_id', filters.author_id);
    }

    if (filters.category_id) {
      queryParams.append('category_id', filters.category_id);
    }

    if (filters.tag_ids && filters.tag_ids.length > 0) {
      queryParams.append('tag_ids', filters.tag_ids.join(','));
    }

    if (filters.title) {
      queryParams.append('title', filters.title);
    }

    if (filters.state) {
      queryParams.append('state', filters.state);
    }

    if (filters.date_from) {
      queryParams.append('date_from', filters.date_from);
    }

    if (filters.date_to) {
      queryParams.append('date_to', filters.date_to);
    }

    if (filters.offset) {
      queryParams.append('offset', filters.offset.toString());
    }

    if (filters.limit) {
      queryParams.append('limit', filters.limit.toString());
    }

    if (filters.order_by) {
      queryParams.append('order_by', filters.order_by);
    }

    const res = await fetch(`${this.baseUrl}/api/v1/posts?${queryParams}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    });

    if (!res.ok) {
      throw new Error('ERROR');
    }

    return res.json();
  }

  async getById(id) {
    const res = await fetch(`${this.baseUrl}/api/v1/posts/${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    });

    if (!res.ok) {
      throw new Error('ERROR');
    }

    return res.json();
  }

  async create(post) {
    const res = await fetch(`${this.baseUrl}/api/v1/posts`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify(post),
    });

    if (!res.ok) {
      throw new Error('ERROR');
    }

    return res.json();
  }

  async update(id, post) {
    const res = await fetch(`${this.baseUrl}/api/v1/posts/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify(post),
    });

    if (!res.ok) {
      throw new Error('ERROR');
    }

    return res.json();
  }

  async publish(id, post) {
    const res = await fetch(`${this.baseUrl}/api/v1/posts/${id}/publish`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(post),
      credentials: 'include',
    });

    if (!res.ok) {
      throw new Error('ERROR');
    }

    return res.json();
  }

  async unpublish(id) {
    const res = await fetch(`${this.baseUrl}/api/v1/posts/${id}/unpublish`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    });

    if (!res.ok) {
      throw new Error('ERROR');
    }

    return res.json();
  }

  async schedule(id, post) {
    const res = await fetch(`${this.baseUrl}/api/v1/posts/${id}/schedule`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(post),
      credentials: 'include',
    });

    if (!res.ok) {
      throw new Error('ERROR');
    }

    return res.json();
  }
  async unschedule(id) {
    const res = await fetch(`${this.baseUrl}/api/v1/posts/${id}/unschedule`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    });

    if (!res.ok) {
      throw new Error('ERROR');
    }

    return res.json();
  }

  async delete(id) {
    const res = await fetch(`${this.baseUrl}/api/v1/posts/${id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    });

    if (!res.ok) {
      throw new Error('ERROR');
    }

    return res.json();
  }

  async pinToHome(id) {
    const res = await fetch(`${this.baseUrl}/api/v1/posts/${id}/pin`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    });

    if (!res.ok) {
      throw new Error('ERROR');
    }

    return res.json();
  }

  async unpinFromHome(id) {
    const res = await fetch(`${this.baseUrl}/api/v1/posts/${id}/unpin`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    });

    if (!res.ok) {
      throw new Error('ERROR');
    }

    return res.json();
  }
}
